export interface IStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
  key(index: number): string | null;
  readonly length: number;
}

export class WebStorage {
  constructor(private readonly storage: IStorage) {}

  public getItem<T>(key: string): T | null {
    try {
      const item = this.storage.getItem(key);
      if (item === null) {
        return null;
      }
      return JSON.parse(item) as T;
    } catch (error) {
      console.warn(`Failed to parse storage item for key "${key}":`, error);
      return null;
    }
  }

  public setItem<T>(key: string, value: T): boolean {
    try {
      const serialized = JSON.stringify(value);
      this.storage.setItem(key, serialized);
      return true;
    } catch (error) {
      console.error(`Failed to serialize storage item for key "${key}":`, error);
      return false;
    }
  }

  public removeItem(key: string): void {
    this.storage.removeItem(key);
  }

  public getAllKeys(): string[] {
    const keys: string[] = [];
    for (let i = 0; i < this.storage.length; i++) {
      const key = this.storage.key(i);
      if (key !== null) {
        keys.push(key);
      }
    }
    return keys;
  }

  public clear(): void {
    const keys = this.getAllKeys();
    keys.forEach(key => this.removeItem(key));
  }

  public hasItem(key: string): boolean {
    return this.storage.getItem(key) !== null;
  }
}
